import { createContext } from 'react';

import { PortalPublicConfigurationModel } from '@portal-clients/configuration';

export const PortalPublicConfigurationContext = createContext<
  PortalPublicConfigurationModel | undefined
>(undefined);
